// extracted by mini-css-extract-plugin
module.exports = {"ant-form-item":"detail_ant-form-item_2JC3C","btnPasswordGenerator":"detail_btnPasswordGenerator_OcUTt"};